import { createFileRoute } from '@tanstack/react-router';

import { ComingSoonPage } from '@/pages/coming-soon';

export const Route = createFileRoute('/_private/bitacora')({
  component: () => <ComingSoonPage moduleName="Bitácora" />,
});
